<template>
    <div class="refresh">
        
    </div>
</template>

<script>
export default {
    beforeRouteEnter(to, from, next) {
        next(vm => {
            console.log(to.query)
            if(to.query){
                if(to.query.id){
                    vm.$router.replace({path:from.path,query:to.query});
                }else{
                    vm.$router.replace({name:"Common"});
                }
            }else{
                vm.$router.replace(from.path)
            }
        })
    },
};
</script>

